import { ArrowUpRight } from "lucide-react";

export default function Footer() {
  const links = [
    ["Manifesto", "#manifesto", "footer-manifesto-link"],
    ["Services", "#services", "footer-services-link"],
    ["Pricing", "#pricing", "footer-pricing-link"],
    ["Founder", "#founder", "footer-founder-link"],
    ["Contact", "#contact", "footer-contact-link"],
  ];

  return (
    <footer data-testid="site-footer" className="border-t border-white/10 bg-[#050508] pt-24">
      <div className="section-shell">
        <div className="group cursor-default select-none overflow-visible pb-8 text-center" data-testid="footer-brand-signature">
          <div
            role="img"
            aria-label="Tybra Digital logo watermark"
            data-testid="footer-logo-image"
            className="footer-logo-pulse mx-auto"
            style={{ maskImage: "url('/tybra-logo-transparent.png')", WebkitMaskImage: "url('/tybra-logo-transparent.png')" }}
          />
        </div>
        <div className="flex flex-col gap-8 border-t border-white/10 py-10 md:flex-row md:items-center md:justify-between">
          <p data-testid="footer-copyright" className="font-mono text-[10px] uppercase tracking-[0.22em] text-slate-600">© 2026 Tybra Digital / Built for the businesses ready to be seen</p>
          <nav className="flex flex-wrap gap-5">
            {links.map(([label, target, testId]) => (
              <a key={target} data-testid={testId} href={target} className="group flex items-center gap-1 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 transition-colors hover:text-cyan-300">
                {label}<ArrowUpRight className="h-3 w-3 transition-transform group-hover:-translate-y-0.5 group-hover:translate-x-0.5" />
              </a>
            ))}
          </nav>
        </div>
      </div>
    </footer>
  );
}
